export const OPENAI_GPT_5_6_SOL_MODEL_ID = "gpt-5.6-sol" as const;
export const OPENAI_GPT_6_ASTRA_MODEL_ID = "gpt-6-astra" as const;
export const OPENAI_GPT_6_ASTRA_MODEL_REF =
  `openai/${OPENAI_GPT_6_ASTRA_MODEL_ID}` as const;
export const OPENAI_GPT_6_SOL_MODEL_ID = "gpt-6-sol" as const;
export const OPENAI_GPT_6_SOL_MODEL_REF =
  `openai/${OPENAI_GPT_6_SOL_MODEL_ID}` as const;
export const OPENAI_GPT_5_6_SOL_MODEL_REF =
  `openai/${OPENAI_GPT_5_6_SOL_MODEL_ID}` as const;
